var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanySettingsIcon = function SvgCompanySettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.844 9.125c.5-.312 1.156.063 1.156.625v8.5a.74.74 0 0 1-.75.75H8.75a.72.72 0 0 1-.75-.75V5.75A.74.74 0 0 1 8.75 5h3.5a.76.76 0 0 1 .75.75v6.156l4.344-2.781c.5-.312 1.156.063 1.156.625v2.156zM22.5 17.5v-6.375l-4.375 2.781c-.5.313-1.125-.062-1.125-.656v-2.125l-4.375 2.781c-.5.313-1.125-.062-1.125-.656V6.5h-2v11z"
  })));
};
export default SvgCompanySettingsIcon;